// extracted by mini-css-extract-plugin
module.exports = {"layer":"Loading_layer__3iZrX"};